// extracted by mini-css-extract-plugin
export var center = "_3r-2";
export var clickableRow = "_3r-5";
export var expandedRow = "_3r-7";
export var hoverable = "_3r-4";
export var left = "_3r-1";
export var right = "_3r-3";
export var row = "_3r-0";
export var selectedRow = "_3r-6";